/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import {combineEpics, Epic} from 'redux-observable';
import {filter, ignoreElements, mergeMap, tap} from 'rxjs/operators';
import {isActionOf} from 'typesafe-actions';
import {applicationStarted} from '../actions';
import {iamStompClient} from '../services';
import {stompClientConnectionEstablished, stompClientWebSocketErrorOccurred} from '../services/Stomp/actions';

const connectIamStompClientOnApplicationStarted: Epic = (action$) => action$.pipe(
	filter(isActionOf(applicationStarted)),
	mergeMap(() => iamStompClient.connect())
);

const reloadOnStompConnectionRestored: Epic = (action$) => {
	const clientsWithError: string[] = [];
	action$
		.pipe(filter(isActionOf(stompClientWebSocketErrorOccurred)))
		.subscribe((action) => {
			const clientIdentifier = action.payload.clientIdentifier;
			if (!clientsWithError.includes(clientIdentifier))
				clientsWithError.push(clientIdentifier);
		});
	return action$.pipe(
		filter(isActionOf(stompClientConnectionEstablished)),
		filter((action) => clientsWithError.includes(action.payload.clientIdentifier)),
		tap(() => window.location.reload()),
		ignoreElements()
	);
};

const applicationEpics: Epic = combineEpics(
	connectIamStompClientOnApplicationStarted,
	reloadOnStompConnectionRestored
);

export default applicationEpics;
